import { Card, Collapse, Grid, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import { Basic } from './Basic'
import { Children } from './Children'
import { Disabled } from './Disabled'
import { Label } from './Label'

export const CheckboxComponentsDemo: React.FC = () => {
    const [opened, { toggle }] = useDisclosure(true)
    return (
        <Card withBorder>
            <Title order={2} onClick={toggle}>
                Checkbox
            </Title>
            <Collapse in={opened}>
                <Grid gutter={20}>
                    <Grid.Col span={6}>
                        <Basic />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Label />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Disabled />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Children />
                    </Grid.Col>
                </Grid>
            </Collapse>
        </Card>
    )
}
